import React from "react";
import IconThemePreviewBase from "./IconThemePreviewBase";

function LightThemeIcon() {
  return (
    <IconThemePreviewBase sidebarPathFill="Currentcolor">
      {/* Main content for LightThemeIcon */}
      <g filter="url(#filter1_d_705_60647)">
        <rect width="40" height="16" x="59" y="31" fill="#fff" rx="1" />
      </g>
      <rect width="4" height="4" x="62" y="34" fill="#E2F6FF" rx="1" />
      <rect width="34" height="4" x="62" y="40" fill="#ECF1F5" rx="1" />
      <g filter="url(#filter2_d_705_60647)">
        <rect width="125" height="80" x="59" y="52" fill="#fff" rx="1" />
      </g>
      <g filter="url(#filter3_d_705_60647)">
        <rect width="40" height="16" x="102" y="31" fill="#fff" rx="1" />
      </g>
      <rect width="4" height="4" x="105" y="34" fill="#E2F6FF" rx="1" />
      <rect width="34" height="4" x="105" y="40" fill="#ECF1F5" rx="1" />
      <g filter="url(#filter4_d_705_60647)">
        <rect width="40" height="16" x="144" y="31" fill="#fff" rx="1" />
      </g>
      <rect width="4" height="4" x="147" y="34" fill="#E2F6FF" rx="1" />
      <rect width="34" height="4" x="147" y="40" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="62" y="55" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="62" y="75" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="62" y="95" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="123" y="55" fill="#ECF1F5" rx="1" />
      <rect width="21" height="4" x="123" y="75" fill="#ECF1F5" rx="1" />
      <rect width="57.7" height="6.7" x="62.15" y="61.15" stroke="#ECEEF5" strokeWidth="0.3" rx="1.85" />
      <rect width="57.7" height="6.7" x="62.15" y="81.15" stroke="#ECEEF5" strokeWidth="0.3" rx="1.85" />
      <rect width="118.7" height="27.7" x="62.15" y="101.15" stroke="#ECEEF5" strokeWidth="0.3" rx="1.85" />
      <rect width="57.7" height="6.7" x="123.15" y="61.15" stroke="#ECEEF5" strokeWidth="0.3" rx="1.85" />
      <rect width="57.7" height="6.7" x="123.15" y="81.15" stroke="#ECEEF5" strokeWidth="0.3" rx="1.85" />
      <defs>
        <filter id="filter1_d_705_60647" width="44" height="20" x="57" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_705_60647" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_705_60647" result="shape" />
        </filter>
        <filter id="filter2_d_705_60647" width="129" height="84" x="57" y="51" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_705_60647" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_705_60647" result="shape" />
        </filter>
        <filter id="filter3_d_705_60647" width="44" height="20" x="100" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_705_60647" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_705_60647" result="shape" />
        </filter>
        <filter id="filter4_d_705_60647" width="44" height="20" x="142" y="30" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_705_60647" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_705_60647" result="shape" />
        </filter>
      </defs>
    </IconThemePreviewBase>
  );
}

export default LightThemeIcon;
